import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import PeriodForm from "../../forms/PeriodForm";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { PERIODS_ACTIONS } from "../../../redux/periods/actions";
import {
  periodCreating,
  periodDeleting,
  periodsLoaded,
  periodUpdating,
  selectCalendarPeriods
} from "../../../redux/periods/selectors";
import Confirm from "../../../base/Confirm";
import FullCalendar from "../../forms/fields/FullCalendar";
import { selectEvent } from "../../../redux/preferences/selectors";
import moment from "moment";
import { getZones } from "../../../services/api/zones";

class _Periods extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      periods: this.props.periods,
      activePeriod: undefined,
      periodsLoaded: this.props.periodsLoaded,
      events: [],
      showModal: false,
      currentSelection: {
        start: null,
        stop: null
      },
      filters: {
        "page[number]": 1,
        "page[size]": 50,
        include: "zones"
      },
      zones: undefined,
      middle: moment()
    };

    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleSelect = this._handleSelect.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._handleClick = this._handleClick.bind(this);
    this._centerOnEvent = this._centerOnEvent.bind(this);
  }

  static propTypes = {
    periods: PropTypes.array,
    periodsLoaded: PropTypes.bool,
    loadPeriods: PropTypes.func,
    match: PropTypes.object,
    createPeriod: PropTypes.func,
    updatePeriod: PropTypes.func,
    deletePeriod: PropTypes.func,
    isCreating: PropTypes.bool,
    calendarPeriods: PropTypes.array,
    isUpdating: PropTypes.bool,
    isDeleting: PropTypes.bool,
    event: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    this.props.loadPeriods(this.state.filters, this.props.event.id);
    this._centerOnEvent(this.props);

    getZones({
      "filter[venue_id]": this.props.event.venueId,
      "page[size]": 50
    }).then(data => {
      this.setState({
        zones: data.data
      });
    });
  }

  _centerOnEvent(props) {
    const event = props.event;
    if (event.startsAt !== "" && event.endsAt !== "") {
      const start = moment(event.startsAt);
      const end = moment(event.endsAt);
      const diff = end.diff(start, "days");
      const middle = moment(start).add(Math.floor(diff / 2), "days");
      this.setState({ middle });
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (
      this.state.filters !== nextState.filters ||
      this.props.event.id !== nextProps.event.id
    ) {
      this.props.loadPeriods(nextState.filters, nextProps.event.id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newState = {
      periods: nextProps.periods,
      periodsLoaded: nextProps.periodsLoaded,
      events: nextProps.calendarPeriods
    };

    if (
      (this.props.isCreating && !nextProps.isCreating) ||
      (this.props.isUpdating && !nextProps.isUpdating) ||
      (this.props.isDeleting && !nextProps.isDeleting)
    ) {
      this._closeModal();
      this.props.loadPeriods(this.state.filters, this.props.event.id);
    }

    if (this.props.event.id !== nextProps.event.id) {
      this._centerOnEvent(nextProps);
    }

    this.setState(newState);
  }

  _handleSelect(start, end) {
    const newState = {
      ...this.state,
      showModal: true,
      currentSelection: { start, end }
    };
    document.body.classList.add("modal-open");

    this.setState(newState);
  }

  _handleClick(calEvent, jsEvent, view) {
    this.setState({
      activePeriod: calEvent.period,
      showModal: true
    });
    document.body.classList.add("modal-open");
  }

  _handleSubmit(values) {
    const data = {
      name: values.name,
      type: values.type,
      startsAt: this._mergeDateTime(values.start_date, values.start_time),
      endsAt: this._mergeDateTime(values.end_date, values.end_time),
      color: values.color,
      zoneIds: values.zoneIds,
      optionalZoneIds: values.optionalZoneIds
    };

    if (this.state.activePeriod) {
      this.props.updatePeriod(values.id, data, this.props.event.id);
    } else {
      this.props.createPeriod(data, this.props.event.id);
    }
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this period? This action can not be undone, please make sure no festival is using this period.",
      {
        title: "Delete Period",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deletePeriod(id);
      },
      result => {}
    );
  }

  _mergeDateTime(date, time) {
    return date
      .set({
        hour: time.hours(),
        minute: time.minutes()
      })
      .utcOffset(0)
      .format("YYYY-MM-DD HH:mm:ss");
  }

  _closeModal() {
    this.setState({
      showModal: false,
      activePeriod: undefined
    });
    document.body.classList.remove("modal-open");
  }

  render() {
    const {
      periodsLoaded,
      events,
      showModal,
      currentSelection,
      activePeriod,
      middle,
      zones
    } = this.state;
    const { isCreating, isUpdating, isDeleting } = this.props;

    return [
      <AdminSubHeader title="Periods" key="subheader" breadcrumbs={[]} />,
      <div className="m-content" key="content">
        {periodsLoaded && (
          <div className="row">
            <div className="col-xl-12">
              <div className="m-portlet">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <span className="m-portlet__head-icon">
                        <i className="flaticon-line-graph" />
                      </span>
                      <h3 className="m-portlet__head-text">Periods</h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body">
                  <FullCalendar
                    selectable
                    handleSelect={this._handleSelect}
                    handleClick={this._handleClick}
                    events={events}
                    middle={middle}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>,
      <div key="modal">
        <div
          className="modal fade show"
          id="m_modal_4"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1039"
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  New period
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this._closeModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {zones && (
                <PeriodForm
                  dates={currentSelection}
                  onSubmit={this._handleSubmit}
                  onDelete={this._handleDelete}
                  isCreating={isCreating}
                  isUpdating={isUpdating}
                  isDeleting={isDeleting}
                  closeModal={this._closeModal}
                  period={activePeriod}
                  zones={zones}
                />
              )}
            </div>
          </div>
        </div>
        <div
          className={"modal-backdrop fade " + (showModal ? " show" : "")}
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1038"
          }}
        />
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadPeriods: (filters, eventId) =>
    dispatch(PERIODS_ACTIONS.loadAllRequest(filters, eventId)),
  updateFilters: filters => dispatch(PERIODS_ACTIONS.updateFilters(filters)),
  createPeriod: (values, eventId) =>
    dispatch(PERIODS_ACTIONS.createRequest(values, eventId)),
  updatePeriod: (id, values, eventId) =>
    dispatch(PERIODS_ACTIONS.updateRequest(id, values, eventId)),
  deletePeriod: (id, eventId) =>
    dispatch(PERIODS_ACTIONS.deleteRequest(id, eventId))
});

const mapStateToProps = function(state) {
  return {
    calendarPeriods: selectCalendarPeriods(state),
    periodsLoaded: periodsLoaded(state),
    isCreating: periodCreating(state),
    isUpdating: periodUpdating(state),
    isDeleting: periodDeleting(state),
    event: selectEvent(state)
  };
};

const Periods = connect(mapStateToProps, mapDispatchToProps)(_Periods);

export default Periods;
